import AdminDashboard from './AdminDashboard'

const DashboardWrapper = () => {
  return <AdminDashboard />
}

export {DashboardWrapper}
